// external imports
import React from 'react'
import { TextInput, IconSearch, EventListener, FreeState } from 'quark-web'
import { grey5 } from 'quark-web/styles'
// local imports
import styles from './styles'

const SearchInput = ({ onSubmit }) => (
    <FreeState initialValue="">
        {({ set, state }) => (
            <TextInput
                icon={<IconSearch style={{ ...styles.searchIcon, color: grey5 }} />}
                placeholder="Search Products"
                style={styles.searchInput}
                value={state}
                onKeyPress={evt => {
                    // if we pressed enter
                    if (evt.key === 'Enter') {
                        // pass the state to the submit handler
                        onSubmit({
                            value: state,
                            clear: () => set('')
                        })
                    }
                }}
                onChange={set}
            />
        )}
    </FreeState>
)

export default SearchInput



// WEBPACK FOOTER //
// ./src/components/SearchInput/index.js